import { render, staticRenderFns } from "./YiChang.vue?vue&type=template&id=24ddb0ac&scoped=true"
import script from "./YiChang.vue?vue&type=script&lang=js"
export * from "./YiChang.vue?vue&type=script&lang=js"
import style0 from "./YiChang.vue?vue&type=style&index=0&id=24ddb0ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ddb0ac",
  null
  
)

export default component.exports